import gql from 'graphql-tag';

export const GET_USER_GENERATED_CONTENT_PRODUCTS = gql`
  query GetUserGeneratedContentProducts(
    $id: String!
    $currency: CurrencyCode
    $market: String
    $country: String!
  ) {
    userGeneratedContentEntry(id: $id) {
      products {
        id
        uuid
        title
        productCategory
        gender
        browseVerticals
        media {
          smallImageUrl
        }
        market(currencyCode: $currency) {
          bidAskData(market: $market, country: $country) {
            lowestAsk
          }
        }
        urlKey
        followed
        variants {
          id
          market(currencyCode: $currency) {
            bidAskData(market: $market, country: $country) {
              lowestAsk
            }
          }
        }
      }
    }
  }
`;
